import { render, staticRenderFns } from "./NumberCreate.vue?vue&type=template&id=4cff8006&"
import script from "./NumberCreate.vue?vue&type=script&lang=js&"
export * from "./NumberCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports